module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "case-1"
    }
  }, [_c('h1', [_vm._v("Case 1")]), _vm._v(" "), _c('div', {
    staticClass: "section level21",
    attrs: {
      "id": "clinical-presentation"
    }
  }, [_c('p', {
    staticStyle: {
      "padding-bottom": "6px",
      "letter-spacing": "1px",
      "padding-top": "28px",
      "font-weight": "bold",
      "text-indent": "0px"
    }
  }, [_vm._v("Clinical Presentation")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("A 36-year-old woman with history of abdominal pain and mild abdominal distension. The liver was enlarged on clinical examination. The abdominal ultrasound revealed an enlarged heterogeneous liver.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level21",
    attrs: {
      "id": "radiological-findings"
    }
  }, [_c('p', {
    staticStyle: {
      "padding-bottom": "6px",
      "letter-spacing": "1px",
      "padding-top": "28px",
      "font-weight": "bold",
      "text-indent": "0px"
    }
  }, [_vm._v("Radiological Findings")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "11",
      "src": "media/11.png"
    }
  })]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "list-style": "none",
      "padding-right": "110px",
      "padding-left": "120px"
    }
  }, [_c('li', [_c('p', {
    staticStyle: {
      "text-indent": "20px"
    }
  }, [_c('strong', [_vm._v("Enhanced CT scan, axial (A, B) and MR scan, axial T1 (C), axial T2 fat saturation (D, E) and post-contrast axial T1 (F) images. On CT images,")]), _vm._v(" the liver is enlarged with hypertrophied caudate lobe: mottled enhancement with prominent enhancement of the central liver and decreased enhancement of the liver periphery (nutmeg liver). The areas of decreased enhancement are due to decreased portal flow, hepatic congestion and ischemia. Non-visualisation of the hepatic veins. The MR sequences show the same appearances with homogeneous liver on T2 and enhancement of the central liver (the caudate lobe enhances normally as it has a separate draining vein directly into the inferior vena cava) with decreased signal intensity of the atrophied liver periphery. The IVC is patent. Note mild ascites.")])])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px",
      "padding-top": "15px"
    }
  }, [_c('strong', [_vm._v("Diagnosis:")]), _vm._v(" Budd Chiari Syndrome.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2cea7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch007.vue
// module id = 84
// module chunks = 0